<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <div class="d-flex justify-content-between align-items-center w-100 mb-3">
        <h3>Свод расчетные</h3>
      </div>

      <div class="filters">
        <div>
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="filterYear" class="form-label col-md-3">
                Год
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.academicYear" id="filterYear"
                        @change="reloadList()"
                        class="form-select">
                  <option v-for="(year, index) in filterYears" :key="index" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">
      <b-button class="btn btn-success" @click="openCreateDialog">
        Сформировать
      </b-button>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(academicYear)="data">
        <div class="sortable-container none"
             @click="onSortChanged('academicYear')"
             :class="{'ascending': page.sort.academicYear === 'ASC', 'descending': page.sort.academicYear === 'DESC'}">
          Год
        </div>
      </template>
      <template #head(status)="data">
        Статус
      </template>
      <template #head(universityName)="data">
        <div class="sortable-container none"
             @click="onSortChanged('universityName')"
             :class="{'ascending': page.sort.universityName === 'ASC', 'descending': page.sort.universityName === 'DESC'}">
          ВУЗ
        </div>
      </template>
      <template #head(createdAt)="data">
        <div class="sortable-container none"
             @click="onSortChanged('createdAt')"
             :class="{'ascending': page.sort.createdAt === 'ASC', 'descending': page.sort.createdAt === 'DESC'}">
          Дата формирования
        </div>
      </template>
      <template #head(actions)="data">
      </template>

      <template #cell(academicYear)="data">
        {{ data.item.academicYear }}
      </template>

      <template #cell(universityName)="data">
        {{ data.item.universityName || 'Сводный (Все ВУЗы)' }}
      </template>

      <template #cell(status)="data">
        <b-badge :variant="getStatusVariant(data.item.status)">
          {{ getStatusLabel(data.item.status) }}
        </b-badge>
      </template>
      
      <template #cell(createdAt)="data">{{ formatDate(data.item.createdAt) }} </template>

      <template #cell(actions)="data">
        <div class="action-cell">
          <el-button v-if="data.item.status === 'DONE'" type="text" class="btn-icon btn-excel" title="Скачать Excel"
                     @click="onClickDownload(data.item)">
            <font-awesome-icon :icon="['fas', 'file-excel']"/>
          </el-button>
          <b-button class="btn btn-danger btn-sm delete-button ms-2"
                    @click="onClickDelete(data.item)">
            Удалить
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <b-modal id="create-modal" title="Сформировать отчет" v-model="dialogVisible" @ok="handleCreate" ok-title="Сформировать" cancel-title="Отмена" :ok-disabled="creating">
    <b-form-group label="Год" label-for="year-select">
      <b-form-select v-model="selectedYear" :options="availableYears" id="year-select"></b-form-select>
    </b-form-group>
    <b-form-group v-if="isAdmin() || isManagerFC() || isAdminReadOnly()" label="ВУЗ" label-for="university-select">
      <multiselect
          v-model="selectedUniversity"
          :options="universities"
          placeholder="Выберите ВУЗ (необязательно)"
          label="nameRu"
          track-by="universityId"
          :multiple="false"
          :allow-empty="true">
      </multiselect>
    </b-form-group>
  </b-modal>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import summaryCalculatedService from "@/services/summaryCalculatedService";
import universityService from "@/services/universityService";
import Multiselect from "vue-multiselect";
import dayjs from "dayjs";
import { saveAs } from "@/assets/FileSaver.min";

export default {
  components: {
    VueLoading,
    Multiselect
  },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      isLoading: false,
      dialogVisible: false,
      creating: false,
      selectedYear: currentYear,
      availableYears: [currentYear - 1, currentYear, currentYear + 1],
      page: {
        filter: {
          academicYear: currentYear
        },
        sort: {
          academicYear: 'DESC',
          createdAt: null
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'universityName', label: 'ВУЗ', sortable: true},
        {key: 'academicYear', label: 'Год', sortable: true},
        {key: 'status', label: 'Статус', sortable: false},
        {key: 'createdAt', label: 'Дата формирования', sortable: true},
        {key: 'actions', sortable: false}
      ],
      items: [],
      universities: [],
      selectedUniversity: null,
      filterYears: Array.from({length: 7}, (v, i) => 2024 + i),
    };
  },
  methods: {
    init() {
      this.initUniversities();
      this.reloadList();
    },
    initUniversities() {
      if (this.isAdmin() || this.isManagerFC() || this.isAdminReadOnly()) {
        const params = {
          partNumber: 1,
          countInPage: 0,
          filter: {}
        };
        universityService.getAll(params)
            .then(response => {
              this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
            });
      }
    },
    async reloadList() {
      this.isLoading = true;
      try {
        const response = await summaryCalculatedService.getList(this.page);
        this.items = response.list;
        this.totalCount = response.count;
      } catch (e) {
        showErrorNotify('Ошибка при загрузке данных');
      } finally {
        this.isLoading = false;
      }
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    async onClickDownload(item) {
      this.isLoading = true;
      try {
        const response = await summaryCalculatedService.download(item.uuid);
        const blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        saveAs(blob, "ВУЗ_СВОД_РАСЧЕТНЫЕ_ЗП_" + item.academicYear + ".xlsx");
      } catch (error) {
        showErrorNotify('Ошибка при скачивании файла');
      } finally {
        this.isLoading = false;
      }
    },
    async onClickDelete(item) {
      if (confirm('Вы уверены, что хотите удалить этот отчет?')) {
        this.isLoading = true;
        try {
          await summaryCalculatedService.deleteById(item.uuid);
          showSuccessNotify('Отчет успешно удален');
          this.reloadList();
        } catch (error) {
          showErrorNotify('Ошибка при удалении отчета');
        } finally {
          this.isLoading = false;
        }
      }
    },
    openCreateDialog() {
      this.selectedUniversity = null;
      this.dialogVisible = true;
    },
    async handleCreate(bvModalEvent) {
      bvModalEvent.preventDefault();
      
      this.creating = true;
      try {
        const uniId = this.selectedUniversity ? this.selectedUniversity.universityId : null;
        await summaryCalculatedService.generate(this.selectedYear, uniId);
        showSuccessNotify('Отчет успешно сформирован');
        this.dialogVisible = false;
        this.reloadList();
      } catch (error) {
        showErrorNotify('Ошибка при формировании отчета');
      } finally {
        this.creating = false;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      return dayjs(dateStr).format('DD.MM.YYYY HH:mm');
    },
    getStatusLabel(status) {
      switch (status) {
        case 'IN_PROGRESS': return 'Формируется';
        case 'DONE': return 'Сформирован';
        case 'ERROR': return 'Ошибка';
        default: return status;
      }
    },
    getStatusVariant(status) {
      switch (status) {
        case 'IN_PROGRESS': return 'warning';
        case 'DONE': return 'success';
        case 'ERROR': return 'danger';
        default: return 'secondary';
      }
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },
    isAdminReadOnly() {
      return delegationService.isAdminReadOnly();
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.ascending {
  background-image: url("../assets/asc.svg") !important;
}

.descending {
  background-image: url("../assets/desc.svg") !important;
}

.none {
  background-image: url("../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.btn-icon {
  font-size: 30px;
  cursor: pointer;
  transition: color 0.3s;
  margin-right: 2px;
}

.btn-excel {
  color: green;
}

.btn-excel:hover {
  color: #85ce61;
}

.delete-button {
  display: flex;
  align-items: center;
}
</style>
